import React from "react";
import SampleDp from "../../assets/Images/sample-dp.png";
import { ReactComponent as ArrowUpIm } from "../../assets/Icons/Universal/BsBoxArrowUpRight.svg";
import "../../styles/ComponentsStyles/Universal/CustomHeaderBox.style.css";
// Step 1: Define the data
const headerData = {
  profileImage: SampleDp,
  name: "Taufik Alam",
  gender: "Male",
  id: "SM0523019",
  position: "Biology Teacher",
  lastFeeDate: "23 Oct, 2025",
  lastMonth: "August",
};

// Step 2: Use the data in your component
const CustomHeaderBox = ({ action }) => {
  return (
    <div className="CustomHeaderTitleContainer">
      <div className="frontSection">
        <div className="profile-dp">
          <img src={headerData.profileImage} alt="dp" />
          <div className="infoContainer">
            <div className="name">{headerData.name}</div>
            <div className="gender">{headerData.gender}</div>
          </div>
        </div>
        <span onClick={action} className="seeHistory">
          See History <ArrowUpIm />
        </span>
      </div>
      <div className="id">#{headerData.id}</div>
      <div className="class">{headerData.position}</div>
      <div className="date">
        <div className="lastFee">
          Last fees collect: {headerData.lastFeeDate}
        </div>
        <div className="period">Last month: {headerData.lastMonth}</div>
      </div>
    </div>
  );
};

export default CustomHeaderBox;
